import { Breadcrumb, Card, Image } from 'antd';
import React, { useEffect } from 'react';
import 'react-alice-carousel/lib/alice-carousel.css'
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
// import { useParams } from 'react-router-dom';
import i18n from '../i18n';
import { CardSingle } from './utilities/CardSingle';
import { CarouselViewer } from './utilities/Carousel';

export const ElectricTransport = () => { 

  const { t } = useTranslation();
  // let { lng } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
    return (
      <React.Fragment>
        <Helmet>
            <title>InnoTrans | {t('common:electrictransport')}</title>
            <meta name="description" content={t('pageDescriptions:electrictransport')} />
            <meta name="keywords" content={t('pageKeywords:electrictransport')} />
            <meta httpEquiv="content-language" content={i18n.language?.substr(0,2)} />
            {/* <link rel="canonical" href={`https://innotrans.nl${lng ? `/${lng}` : ''}/wheelchaircar`} /> */}
        </Helmet>
        
         <Breadcrumb style={{ margin: '16px 0', paddingLeft: '50px' }}>
            <Breadcrumb.Item><h1>{t('common:electrictransport')}</h1></Breadcrumb.Item>
        </Breadcrumb>

        <CarouselViewer id='10cb198c-832f-4202-b9a5-8429dea87b57' />

        <CardSingle title={t('electrictransport:card1-title')}>
          <div dangerouslySetInnerHTML={{__html: t('electrictransport:card1-text') }} />
          <br/>
          <br/>          <div>
            <div className='bullet-list' style={{ lineHeight: 2}}>
              <div className='bullet-item'>
                <img src={'/images/brands/mercedes.png'} alt='' className='bullet-image-larger' /> Mercedes-Benz Sprinter<br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/vw.jpg'} alt='' className='bullet-image-larger'/> Volkswagen Crafter<br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/man.png'} alt='' className='bullet-image-larger'/> MAN TGE<br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/fiat.png'} alt='' className='bullet-image-larger'/> Fiat Ducato<br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/peugeot.png'} alt='' className='bullet-image-larger'/> Peugeot Boxer<br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/opel.png'} alt='' className='bullet-image-larger'/> Opel Movano<br/>
              </div>
              <div className='bullet-item'>
                <img src={'/images/brands/citroen.png'} alt='' className='bullet-image-larger'/> Citroen Jumper<br/>
              </div>
            </div>
          </div>
        </CardSingle>

      </React.Fragment>
    )
}